import { render } from "./NetworkBadge.vue?vue&type=template&id=34747650&scoped=true"
import script from "./NetworkBadge.vue?vue&type=script&lang=js"
export * from "./NetworkBadge.vue?vue&type=script&lang=js"

import "@/Common/Styles/networkBadge.scss?vue&type=style&index=0&id=34747650&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34747650"]])

export default __exports__